module.exports = __webpack_public_path__ + "./docs/img/icon-folder.d8442b9c95ac4d147e4d262d42f33feb.svg";